/**
 *
 * ui_loopSliderHoverFreeze.js
 *
 *
 */
(() => {


	/**************************************************************
	 * loopSliderをhoverして止める処理
	**************************************************************/
	class loopSliderHoverFreeze {
		constructor(options) {
			const defaults = {
				wrapperSelector: '.js-loopsliders',
				contentSelector: '.js-loopslider__content',
				axis: 'x'
			};

			this.options  = Object.assign({}, defaults, options || {});
			this.wrappers = document.querySelectorAll(this.options.wrapperSelector);

			if (!this.wrappers.length) {
				this.enabled = false;
				return;
			}

			this.enabled = true;
			this.store = new WeakMap();

			this.onEnter = this.onEnter.bind(this);
			this.onLeave = this.onLeave.bind(this);

			this.bind();
		}

		bind() {
			for (let i = 0; i < this.wrappers.length; i++) {
				this.wrappers[i].addEventListener('mouseenter', this.onEnter);
				this.wrappers[i].addEventListener('mouseleave', this.onLeave);
			}
		}

		onEnter(e) {
			const wrapper = e.currentTarget;
			const contents = wrapper.querySelectorAll(this.options.contentSelector);

			for (let i = 0; i < contents.length; i++) {
				this.freezeToMargin(contents[i]);
			}
		}

		onLeave(e) {
			const wrapper = e.currentTarget;
			const contents = wrapper.querySelectorAll(this.options.contentSelector);

			for (let i = 0; i < contents.length; i++) {
				this.restoreFromMargin(contents[i]);
			}
		}

		freezeToMargin(el) {
			if (!this.store.has(el)) {
				this.store.set(el, {
					inline: {
						animationName: el.style.animationName,
						animationPlayState: el.style.animationPlayState,
						transform: el.style.transform,
						marginLeft: el.style.marginLeft,
						marginTop: el.style.marginTop
					},
					currentTimes: []
				});
			}

			const saved = this.store.get(el);

			el.style.animationPlayState = 'paused';
			el.getBoundingClientRect();

			const cs = getComputedStyle(el);
			const t = this.getTranslateFromTransform(cs.transform, this.options.axis);

			saved.currentTimes = [];
			if (el.getAnimations) {
				const anims = el.getAnimations();
				for (let i = 0; i < anims.length; i++) {
					saved.currentTimes.push(anims[i].currentTime);
				}
			}

			if (this.options.axis === 'y') {
				el.style.marginTop = t + 'px';
			} else {
				el.style.marginLeft = t + 'px';
			}

			el.style.animationName = 'none';
			el.style.transform = 'none';
			el.getBoundingClientRect();
		}

		restoreFromMargin(el) {
			const saved = this.store.get(el);
			if (!saved) return;

			el.style.animationPlayState = 'paused';
			el.style.animationName = saved.inline.animationName;
			el.getBoundingClientRect();

			if (el.getAnimations && saved.currentTimes && saved.currentTimes.length) {
				const anims = el.getAnimations();
				const max = Math.min(anims.length, saved.currentTimes.length);

				for (let i = 0; i < max; i++) {
					if (saved.currentTimes[i] == null) continue;
					try { anims[i].currentTime = saved.currentTimes[i]; } catch (err) {}
				}
			}

			el.getBoundingClientRect();

			el.style.marginLeft = saved.inline.marginLeft;
			el.style.marginTop = saved.inline.marginTop;
			el.style.transform = saved.inline.transform;
			el.style.animationPlayState = 'running';
		}

		getTranslateFromTransform(transformValue, axis) {
			if (!transformValue || transformValue === 'none') return 0;

			const m = transformValue.match(/matrix(3d)?\((.+)\)/);
			if (!m) return 0;

			const is3d = !!m[1];
			const parts = m[2].split(',');
			const nums = [];

			for (let i = 0; i < parts.length; i++) {
				nums.push(parseFloat(parts[i].trim()));
			}

			if (is3d) {
				if (axis === 'y') return Number.isFinite(nums[13]) ? nums[13] : 0;
				return Number.isFinite(nums[12]) ? nums[12] : 0;
			}

			if (axis === 'y') return Number.isFinite(nums[5]) ? nums[5] : 0;
			return Number.isFinite(nums[4]) ? nums[4] : 0;
		}
	}

	new loopSliderHoverFreeze({
		wrapperSelector: '.js-loopsliders',
		contentSelector: '.js-loopslider__content',
		axis: 'x'
	});






})();
